var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"02df2db7bcf03d6ae07974f31e80ef1274d54616"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sanity-blog@ownup"]={id:"02df2db7bcf03d6ae07974f31e80ef1274d54616"};
      